import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';
export const selfMergeDPRoot = `Profile|Self Merge`;
export type SelfMergeRouteLocs = 'CPSelfMergeRouteTitle' | 'CPSelfMergeRoutePageDescription';

export const selfMergeRouteLocs: LocDefs<SelfMergeRouteLocs> = {
	CPSelfMergeRouteTitle: {
		defaultValue: 'Merge Accounts',
		description: 'Title displayed on self merge account request and validation pages.',
		displayPath: `${selfMergeDPRoot}|Page Title`,
		displayType: 'Title',
		feature: HubFeature.MergeCandidatesCandidateSelfMerge,
		portal: 'CP',
	},
	CPSelfMergeRoutePageDescription: {
		defaultValue: '',
		description: 'Description displayed on self merge page.',
		displayPath: `${selfMergeDPRoot}|Page Description`,
		displayType: 'Content',
		feature: HubFeature.MergeCandidatesCandidateSelfMerge,
		portal: 'CP',
		htmlAllowed: true,
	},
};
export const LOC_KEYS = MapLocKeys<SelfMergeRouteLocs>(selfMergeRouteLocs);
